import { Component, ViewChild, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { App, NavController, NavParams, LoadingController } from 'ionic-angular';

/* Providers */
import { UserProvider } from '../../../providers/user';
import { AuthProvider } from '../../../providers/auth';
import { LogoutProvider } from '../../../providers/logout';
import { OnPremiseProvider } from '../../../providers/on-premise';
import { NavSidebarProvider } from '../../../providers/nav-sidebar';
import { Subscription } from 'rxjs';

export enum AccountSettingsViews {
    API_KEYS = 'api-keys',
    API_ANALYTICS = 'api-analytics',
    EXPORTS = 'exports',
    ORGANIZATION = 'organization',
    NOTIFICATION_PREFERENCES = 'notification-preferences',
    CHANGE_PASSWORD = 'change-password',
    SWITCH_ACCOUNT = 'switch-account',
    ABOUT = 'about'
}

@Component({
    selector: 'settings-sidebar',
    templateUrl: 'settings-sidebar.html'
})
export class SettingsSidebarComponent implements OnInit, OnDestroy {
    @Input() public currentView;
    @Output() public viewChangedEvent = new EventEmitter<string>();

    public views = AccountSettingsViews;

    public datasetIdentifier: string | undefined;
    public projectIdentifier: string | undefined;
    public metadataSubscription: Subscription;

    public isLicenseExpiringSoon = false;

    constructor(
        @ViewChild('myNav') public navCtrl: NavController,
        public navParams: NavParams,
        public appCtrl: App,
        public userProvider: UserProvider,
        public loadingCtrl: LoadingController,
        public logoutProvider: LogoutProvider,
        public onPremiseProvider: OnPremiseProvider,
        public authProvider: AuthProvider,
        public navSidebarProvider: NavSidebarProvider
    ) {}

    async ngOnInit() {
        this.metadataSubscription = this.navSidebarProvider.currentMetadataSubscription.subscribe(metadata => {
            if (!metadata) {
                return;
            }

            this.projectIdentifier = metadata.projectIdentifier;
            this.datasetIdentifier = metadata.datasetIdentifier;
        });

        const licenseExpirationDate = await this.onPremiseProvider.getLicenseExpirationDate();

        this.isLicenseExpiringSoon =
            licenseExpirationDate !== '' && this.onPremiseProvider.isLicenseExpiringSoon(licenseExpirationDate);
    }

    ngOnDestroy() {
        this.metadataSubscription.unsubscribe();
    }

    // can be moved to app component in future if we have logout function at multiple locations
    /**
     * Logout user from the application
     */
    public async logout(): Promise<any> {
        try {
            await this.logoutProvider.logout();
            this.appCtrl.getActiveNavs()[0].setRoot('LoginPage');
        } catch (err) {
            throw err;
        }
    }

    public onViewChanged(newView: AccountSettingsViews) {
        this.currentView = newView;
        this.viewChangedEvent.emit(newView);
    }

    public canUseAPIAnalytics(): boolean {
        return this.userProvider.canManageDatasets() && this.userProvider.hasInferenceAPICapability();
    }

    public createUpgradeLink(): string | undefined {
        const user = this.userProvider.getUserInformation();

        // this prevents user from being undefined and breaking the page if there's a delay in fetching the user in ngOnInit.
        if (user.name) {
            const nameSplit = user.name.split(' ');

            // This assumes that the user has only a first and last name; this might be difficult for non-Western names or those with double names
            const firstName = nameSplit.shift();
            const lastName = nameSplit.join(' ');
            const email = user.email.replace(/\+/g, '%2B');

            return `https://info.neurala.com/upgrade?firstname=${firstName}&lastname=${lastName}&email=${email}`;
        }
    }

    public createKBLink(): string {
        return `http://support.neurala.com/home/`;
    }

    public canDisplayOrganizationOption(): boolean {
        return !this.onPremiseProvider.isOnPremiseElectronApp();
    }
}



// WEBPACK FOOTER //
// ./src/components/core/settings-sidebar/settings-sidebar.ts